import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/maintenance")({
  component: MaintenancePage,
});

function MaintenancePage() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-4 p-6">
      <h1 className="text-xl font-bold">メンテナンス中</h1>
      <p className="max-w-md text-center text-sm text-muted-foreground">
        メンテナンス中のため、管理画面を利用できません。
      </p>
    </div>
  );
} 
